import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/WebLayouts/Header';
import Footer from '../../components/WebLayouts/Footer';
import '../../components/WebLayouts/legal-pages.css';

export default function TermsAndConditions() {
  const navigate = useNavigate();

  const goHome = () => {
    navigate('/');
  };

  return (
    <div className="wrapper">
      <Header />
      <div className="container my-5" style={{paddingTop:'100px'}}>
        <div className="legal-page">
          <h1>Terms and Conditions</h1>
          
          <p>By using the Website and Services, you agree to these Terms & Conditions. If you disagree with any part of these Terms & Conditions, you may not use the Website or Services.</p>
          
          <h4>1. Use of Website and Services</h4>
          <p>By using the Website and Services, you agree to these Terms & Conditions. If you disagree with any part of these Terms & Conditions, you may not use the Website or Services.</p>
          
          <h4>2. Orders</h4>
          <p>When you place an order for gas, you agree to pay the listed price for the gas and any applicable delivery fees. You are responsible for ensuring that the delivery address you provide is accurate and complete.</p>
          
          <h4>3. Cancellations and Refunds</h4>
          <p>We may accept cancellations of orders before the gas has been dispatched. Please contact us as soon as possible if you wish to cancel your order. We offer refunds for orders that are not delivered due to our fault. We do not offer refunds for orders that are cancelled after the gas has been dispatched.</p>
          
          <h4>4. Disclaimer</h4>
          <p>We make no warranties, expressed or implied, about the Website or Services. The Website and Services are provided "as is" and without warranties of any kind, including, but not limited to, the implied warranties of merchantability, fitness for a particular purpose, and non-infringement.</p>
          
          <h4>5. Limitation of Liability</h4>
          <p>We shall not be liable for any damages arising from your use of the Website or Services, including, but not limited to, direct, indirect, incidental, special, consequential, or punitive damages.</p>
          
          <h4>6. Governing Law</h4>
          <p>These Terms & Conditions shall be governed by and construed in accordance with the laws of Nigeria.</p>
          
          <h4>7. Changes to these Terms & Conditions</h4>
          <p>We may change these Terms & Conditions at any time. The changes will be effective upon posting on the Website. You are responsible for checking these Terms & Conditions periodically for changes.</p>
          
          <h4>8. Contact Us</h4>
          <p>If you have any questions about these Terms & Conditions, please contact us:</p>
          <ul>
            <li>By email: info@neongas.ng</li>
            <li>By phone: +2349090000130</li>
          </ul>
          
          <div className="text-center mt-4">
            <button className="btn btn-primary" onClick={goHome}>
              Back to Home
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}